<template>
  <a-select
    @focus="focus"
    :allowClear="allowClear"
    :value="value"
    placeholder="请选择"
    @change="$emit('input', $event)"
  >
    <a-select-option :key="val.dictCode" v-for="(val) in dataMap" :value="val.dictCode">{{ val.dictName }}</a-select-option>
  </a-select>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    value: { type: String, default: '' },
    type: { type: String, default: '' },
    allowClear: { type: Boolean, default: true }
  },
  data() {
    return {
      dataMap: {},
    }
  },
  async mounted() {
    this.focus()
  },
  methods: {
    async focus() {
      // this.dataMap = await this.getDict(this.type)
      switch (this.type) {
        case 'group':
          const res = await this.$http.get('/p/material/web/group', { params: { size: 1000 } })
          for (const item of res.records) {
            item.dictName = item.title
            item.dictCode = item.id
          }
          this.dataMap = res.records
          // const theData = {}
          // records.forEach(item => {
          //   theData[item.id] = item.title
          // })
          // this.dataMap = theData
          break
        case 'province':
          const pro = await this.$http.get('p/web/geoArea/children')
          for (const i of pro) {
            i.dictName = i.areaName
            i.dictCode = i.id + ''
          }
          this.dataMap = pro
          break
           case 'lever':
          const info = await this.$http.get('/p/web/memberLever/getLevers')
          for (const item of info) {
            item.dictName = item.name
            item.dictCode = item.id
          }
          this.dataMap = info
          break
        case 'memberType':
          this.dataMap = [{
            dictName: '官方购买(月)',
            dictCode: '0'
          }, {
            dictName: '积分商城(天)',
            dictCode: '1'
          }]
          break
        default:
          const rz = await this.$http.get(`/p/web/dict/list/${this.type}`)
          this.dataMap = rz
      }
    },
    ...mapActions('materiel', ['getDict']),
  },
}
</script>
